export default __webpack_public_path__ + "static/ciprian_bw-a77ee2e0e81e7bc8c0b3d638b64198b2.jpg";